import {
  authConfig,
  appTilesConfig,
  departmentContacts,
  bulletins,
  techManualsTableConfig,
  techBulletinsTableConfig,
} from '../config';
import { identity } from '@gplibraries/react/identity';

/**
 * Bootstrap application configuration.
 */
export default function createConfig() {

  const appConfig = {
    environment: import.meta.env.CLIENT_ENVIRONMENT,
    authConfig: authConfig,
    departmentContacts: departmentContacts,
    dealerAccessApiHost: import.meta.env.CLIENT_MIDDLEWARE_HOST,
    dealerAccessApiScope: import.meta.env.CLIENT_MIDDLEWARE_SCOPE,
    drupalScope: import.meta.env.CLIENT_DRUPAL_SCOPE,
    appTilesConfig: appTilesConfig,
    theme: import.meta.env.CLIENT_DEFAULT_THEME,
    identity: identity,
    bulletins: bulletins,
    techManualsTableConfig: techManualsTableConfig,
    techBulletinsTableConfig: techBulletinsTableConfig,
    rviHost: import.meta.env.CLIENT_RVI_HOST,
  }

  return appConfig;

}
